import { AttendanceDataForm } from './componenets/attendance-data-form';
import React, { useMemo } from 'react';
import { LectureDetails } from '../../../../../../api/types/lecturers/details/lecture-details';
import { UserAttendanceRequest } from '../../../../../../api/types/lecturers/attendance/user-attendance-request';
import { updateAttendanceOperations } from './operations/update-attendance-operations';
import globalProgramStore from '../../../../../../stores/program-store';
import globalLectureBuilderStore from '../../../../../../stores/global-lecture-builder-store';

interface AttendanceLessonStartedDataFormDataModel {
  lectureDetails: LectureDetails;
}
export const AttendanceLessonStartedDataForm: React.FC<
  AttendanceLessonStartedDataFormDataModel
> = ({ lectureDetails }) => {
  const data = lectureDetails!.attendance.map((item) => ({
    student: item.student,
    attendanceType: item.attendance.attendanceType,
  }));

  const lecture = useMemo(
    () => globalLectureBuilderStore.selectedLecture,
    [globalLectureBuilderStore.selectedLecture],
  );

  const handleCompleteLecture = async (attendance: UserAttendanceRequest[]) => {
    // Create a map for faster lookups
    const currentAttendanceMap = new Map(
      data.map((item) => [item.student.id, item.attendanceType]),
    );

    // Calculate the delta - find entries where attendance type has changed
    const delta = attendance.filter(
      (newItem) =>
        currentAttendanceMap.get(newItem.studentId) !== newItem.attendance,
    );

    const programId = globalProgramStore.getCurrentId();
    await updateAttendanceOperations(programId, lecture, delta);
  };

  return (
    <div>
      <AttendanceDataForm
        attendanceDataModel={data}
        handleCompleteLecture={handleCompleteLecture}
      />
    </div>
  );
};
